import { v4 as uuid } from 'uuid';

import { IOldFiltersFromSet } from '@/bundles/GroupFilters/interfaces/mappers/IOldFiltersFromSet';
import { IGroupFilterItem } from '@/bundles/GroupFilters/helpers/getDefaultFiltersObj';
import { Nullable } from '@/utils/types';
import { MARKER_ISOCHRONE_FILTER_KEY, FREE_ISOCHRONE_FILTER_KEY, LAYER_IDS_FILTER_KEY } from '@/bundles/Map/constants';

export const getDefaultFilterObj = ({ title, value, formattedValue = 'True', isEditDisabled = true }: {
  title: string;
  value: any;
  formattedValue?: string;
  isEditDisabled?: boolean;
}) => ({
  id: uuid(),
  title: title,
  value,
  formattedValue,
  isEditDisabled,
})

export const FILTER_KEYS_WITHOUT_CONFIG = [
  'polygon',
  'exclude_polygon',
  'circle_polygon',
  'viewport_polygon',
  'filteredItems',
  'excludedItems',
  'focus_area',
  MARKER_ISOCHRONE_FILTER_KEY,
  FREE_ISOCHRONE_FILTER_KEY,
  LAYER_IDS_FILTER_KEY,
];

export const mapOldFilterWithoutConfig = (filter: IOldFiltersFromSet, currentUserId?: number): Nullable<IGroupFilterItem> => {
  if (!FILTER_KEYS_WITHOUT_CONFIG.includes(filter.name)) return null;

  if (filter.name === 'polygon' || filter.name === 'exclude_polygon') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: filter.name === 'exclude_polygon' ? 'Excluded by polygon' : 'Filtered by polygon',
        value: filter.value,
      }),
    };
  }

  if (filter.name === 'circle_polygon') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filtered by circle',
        value: filter.value,
      })
    };
  }

  if (filter.name === 'viewport_polygon') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filter by viewport',
        value: filter.value,
      })
    };
  }

  if (filter.name === 'filteredItems') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filtered Items',
        value: filter.value,
        isEditDisabled: false,
      })
    };
  }

  if (filter.name === 'excludedItems') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Excluded Items',
        value: filter.value,
        isEditDisabled: false,
      })
    };
  }

  if (filter.name === MARKER_ISOCHRONE_FILTER_KEY) {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filter By Marker Isochrone',
        value: filter.value
      })
    };
  }

  if (filter.name === FREE_ISOCHRONE_FILTER_KEY) {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filter By Free Isochrone',
        value: filter.value
      })
    };
  }

  if (filter.name === LAYER_IDS_FILTER_KEY) {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Filter Selected Layers',
        value: filter.value,
      }),
    };
  }

  if (filter.name === 'focus_area') {
    return {
      [filter.name]: getDefaultFilterObj({
        title: 'Focus Area',
        value: filter.value,
        formattedValue: filter.value.member_id === currentUserId ? 'My' : filter.value.member_name,
        isEditDisabled: true
      })
    };
  }

  return null;
}
